import { jsx as _jsx } from "react/jsx-runtime";
import * as OutlineIcons from "@heroicons/react/24/outline";
import * as SolidIcons from "@heroicons/react/24/solid";
const Icon = ({ variant, name = "QuestionMarkCircleIcon", ...props }) => {
    const variantIcon = variant === "outline" ? OutlineIcons : SolidIcons;
    const Icon = name ? variantIcon[name] : OutlineIcons.QuestionMarkCircleIcon;
    if (!Icon) {
        const DefaultIcon = OutlineIcons.QuestionMarkCircleIcon;
        return _jsx(DefaultIcon, { "editor-icon": "true", ...props });
    }
    return _jsx(Icon, { "editor-icon": "true", ...props });
};
export default Icon;
//# sourceMappingURL=Icon.js.map